<template>
  <div>
    <!-- 客服 浮动 -->
    <div class="TextFlag">
      <div class="Flagitem kefu" style="background: #5f4aff">
        <a
          target="_blank"
          href="http://wpa.qq.com/msgrd?v=3&uin=2211904562&site=qq&menu=yes"
        >
          <div class="showNav">
            <div class="TB_center">
              <div><img src="./../static/images/kf.png" alt="" /></div>
              <div style="color: #ffffff">在线客服</div>
            </div>
          </div>
        </a>
        <div class="Showcount">123123</div>
      </div>
      <el-popover
        placement="left"
        title="亦邦（深圳）国际物流有限公司"
        width="450"
        trigger="hover"
      >
        <div>
          <p class="showCouText">
            地址：深圳市南山区科技南路18号深圳湾科技生态园12栋A座810室
          </p>
          <div class="showCouText">
            <p class="showCouText el-icon-phone">客服热线:</p>
            <span style="margin-left: 15px">181-0280-6672</span>
          </div>
          <div class="showCouText">
            <p class="showCouText el-icon-phone">前台电话:</p>
            <span style="margin-left: 15px">＋86-755-82143176</span>
          </div>
          <p class="showCouText el-icon-printer">传真：＋86 755-82143174</p>
          <p class="showCouText el-icon-message">邮箱：info@cititrans.com</p>
          <p class="showCouText" style="font-size: 14px">
            <i class="el-icon-chat-dot-round"></i> 微信ID：181-0280-6672
          </p>
          <p style="font-size: 14px; padding-left: 15px">
            专属客服、相关微信客服
          </p>
          <img
            style="width: 130px; height: 130px; margin-left: 15px"
            src="https://0.rc.xiniu.com/g3/M00/07/62/CgAH6F2_5qSAbJcHAABJJ6mvWhI105.png"
            alt=""
          />
          <p style="margin-left: 15px; font-size: 13px; color: #999">
            扫描二维码添加客服微信
          </p>
        </div>
        <div class="Flagitem" slot="reference">
          <div class="showNav">
            <div class="TB_center">
              <div><img src="./../static/images/ip.png" alt="" /></div>
              <div>联系我们</div>
            </div>
          </div>
          <div class="Showcount">占位符</div>
        </div>
      </el-popover>
      <el-popover placement="left" width="100" trigger="hover">
        <div>
          <img
            style="width: 150px; height: 150px"
            src="./../static/images/xcximg.jpg"
            alt=""
          />
        </div>
        <div class="Flagitem" slot="reference">
          <div class="showNav">
            <div class="TB_center">
              <div><img src="./../static/images/xcx.png" alt="" /></div>
              <div>小程序</div>
            </div>
          </div>
          <div class="Showcount">占位符</div>
        </div>
      </el-popover>
      <div class="Flagitem" @click="toTop">
        <div class="showNav">
          <div class="TB_center">
            <div><img src="./../static/images/top.png" alt="" /></div>
            <div>返回顶部</div>
          </div>
        </div>
        <div class="Showcount"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  },

  created() {},
  mounted() {},
};
</script>

<style scoped>
.TextFlag {
  position: fixed;
  width: 260px;
  z-index: 3;
  right: -200px;
  bottom: 250px;
  bottom: 10%;
}
/* 侧边导航 */
.Flagitem {
  cursor: pointer;
  margin-top: 10px;
  width: 260px;
  height: 70px;
  background: #ffffff;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  transition: width 0.5s;
  -webkit-transition: width 0.5s;
  border-radius: 10px 0 0 10px;
  transition: transform 300ms;
  box-shadow: 0px 0px 10px 0px rgba(6, 2, 3, 0.13);
}
.showNav {
  width: 66px;
  height: 70px;
  float: left;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.Showcount {
  width: 200px;
  height: 60px;
  float: left;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.showCouText {
  padding: 10px 0;
  width: 100%;
  float: left;
  font-size: 14px;
}
.kefu:hover {
  transform: translate(-10px, 0px);
  transition: transform 300ms;
  box-shadow: 0px 0px 39px 5px rgba(155, 155, 155, 0.32);
}
</style>


// WEBPACK FOOTER //
// common/serviceText.vue